import React from "react";
import { Box, Grid, Typography, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CUSTOM_CHART_CONFIGS } from "../manageData/Analytics/chartConfigs.js";
export default function Analytics({
  formData,
  isGraphSelected,
  handleGraphToggle,
  saving,
}) {
  const { t } = useTranslation();
  return (
    <Box
      // className="analytics-container"
      sx={{
        border: "1px solid #c8cbd0",
        borderRadius: "12px",
        boxShadow: "-1px 2px 4px 0px #0000001a",
      }}
    >
      <Grid
        container
        spacing={3}
        p={3}
        sx={{
          justifyContent: "center",
          width: "100%",
          margin: " auto",
        }}
      >
        {CUSTOM_CHART_CONFIGS.map((chartConfig) => {
          const isSelected = isGraphSelected(chartConfig.id);
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={2}
              lg={2}
              key={chartConfig.id}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                onClick={() => !saving && handleGraphToggle(chartConfig)}
                sx={{
                  backgroundImage: `url(${chartConfig.img})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  position: "relative",
                  bgcolor: "white",
                  border: isSelected
                    ? "2px solid #20A8E0"
                    : "1px solid #A5DCF3",
                  borderRadius: 2,
                  height: 150,
                  width: "100%" /* Take full width of grid item */,
                  maxWidth: "280px" /* Maximum width for larger screens */,
                  boxShadow: "-1px 2px 4px 0px #00000033",
                  mt: 2,
                  display: "flex",
                  flexDirection: "column",
                  cursor: saving ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: saving ? 0 : 3,
                    borderColor: saving ? undefined : "#20A8E0",
                  },
                  opacity: saving ? 0.6 : 1,
                  p: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Checkbox
                    checked={isSelected}
                    disabled={saving}
                    sx={{
                      padding: 0,
                      pointerEvents: "none",
                      "& .MuiSvgIcon-root": {
                        color: isSelected ? "#20A8E0" : "#bdbdbd",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: isSelected ? "#20A8E0" : "#666",
                      textAlign: "left",
                    }}
                  >
                    {t(chartConfig.title, chartConfig.title)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
